import React, { useContext, useEffect, useRef, useState } from 'react';
import Colors from "constants/Colors";

import { Field } from "formik";
import {
  HeadCoverage,
  TableComponent,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TableColumnCoverageName,
  SmallTitle,
  AddButton,
  ContainerButton,
  TextButton,
  RowName,
  ContractContainer,
  BrokerImage,
  TableColumn,
  InlineLabel,
  TitleAlter,
  TableCollumCoverageItem,
  RowValue,
  ExtraText
} from './styles'
import { GridColumnTitle, Label, CheckBox, Button, FormSection, HasPermission, InputField } from '@fitinsur/components';
import MasksHelper from 'utils/src/masks';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import Icon from 'components/Icon';
import './styles.css';
import ComboBox from '../Form/ComboBox3';
import { SelectField } from "../Form/";

const Table = ({
  calcList,
  history,
  idOperation,
  idProduct,
  formikValues,
  disabled,
  permissions,
  onRecalculate,
  handleCheckCoverage,
  onRecalculateItem,
  onConfirmPlanText,
  onConfirmPlan,
  disabledCommision,
  selectedOption,
  openHistoryModel,
  disabledConfirm,
  readOnlyMode,
  showHistory,
  showCoveragesAndExtensions,
  onOptionsDeductible,
  onSelectDeductible,
  onChoosedDeductible,
  hasCoverageCalc,
  showAlterButton,
  warrantyQuote,
  minComission,
  maxComission,
  isInAnalysis,
  newDisabled,
  productName,
  customButton,
  creditLimits
}) => {
  const maskHelper = new MasksHelper();
  const authContext = useContext(GlobalAuthContext);
  const [coverage, setCoverage] = useState([])
  const [option, setOption] = useState(selectedOption != null ? selectedOption : null);
  const [expanded, setExpanded] = useState(readOnlyMode);
  const [productPlanName, setProductPlanName] = useState(null)
  const parseNumber = (value) => {
    if (typeof (value) === 'string') {
      if (value.startsWith('%')) return Number(value.replaceAll('%', '').replaceAll(',', '.'))

      return Number(value.replaceAll('R$', '').replaceAll('.', '').replaceAll(',', '.'))
    }
    return value
  }

  const formikKey = readOnlyMode ? 'previousCalculationList' : 'calculationList'

  const currencyMask = (maxValue) => ({
    "type": "currency",
    "mask": 0,
    "scale": 2,
    "signed": true,
    "normalizeZeros": false,
    "padFractionalZeros": true,
    "radix": ",",
    "thousandsSeparator": ".",
    "mapToRadix": [
      ".",
      ","
    ],
    "max": maxValue || 999999999999999,
    // "min": 0
  })

  const groupCoverageItems = () => {
    if (!calcList[0].coverageItems?.length) return;

    const arrCoverage = coverage
    calcList.map(calcListItems => {
      setProductPlanName(calcListItems.productPlanName)
      calcListItems.coverageItems.map(item => {
        arrCoverage.push(item)
      })
    });
    const filterCoverageItems = Array.from(new Set(arrCoverage.map(a => a.idProductCoverage)))
      .map(id => {
        return arrCoverage.find(a => a.idProductCoverage === id)
      })

    setCoverage(filterCoverageItems)
  }

  const showOption = (index) => {
    if (!expanded) {
      setOption(index);
      setExpanded(true)
    } else {
      setOption(null);
      setExpanded(false)
    }

  };

  useEffect(() => {
    if (calcList.length) {
      groupCoverageItems()
    }
  }, [calcList]);

  const handleIcons = (index, covIndex) => formikValues?.calculationList[index].coverageItems[covIndex]?.coverageDisabled ? <Icon name='close-red' /> : <Icon name='check' />

  const modalityCreditLimit = creditLimits?.find(
    item => item?.idProductPlan === calcList[0]?.idProductPlan
  );

  const borrowerCreditLimit = creditLimits?.find(
    item => !item?.idProductPlan
  );

  return (
    <>
      <TableComponent>
        <TableHead>
          <TableRow>
            {(hasCoverageCalc && onOptionsDeductible.length && idProduct == 48) ? (
              <>
                <TableHeader>
                  <SmallTitle>Selecione a franquia:</SmallTitle>
                </TableHeader>
                <TableHeader style={{ paddingBottom: '20px' }} colSpan={'100%'}>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1px' }}>
                    <Field
                      style={{ width: '100%', margin: 'auto' }}
                      component={SelectField}
                      disabled={readOnlyMode || disabledCommision}
                      options={onOptionsDeductible}
                      name='optionDeductible'
                      value={formikValues.optionDeductible}
                      placeholder='Selecione a franquia'
                      hidePlaceholder
                      onChange={value => onSelectDeductible && onSelectDeductible(value)}
                    />
                  </div>
                </TableHeader>
              </>
            ) : <></>}
          </TableRow>
          <TableRow>
            <TableHeader className={'empty-th'} width={300} />
            {calcList.map((calculations, index) => {
              if (option != null && index != option) return <></>
              return (
                <TableHeader
                  colSpan={6}
                  style={{
                    textAlign: 'center',
                    color: Colors.WHITE,
                    borderTopRightRadius: 12,
                    borderTopLeftRadius: 12,
                  }}
                  backgroundColor={Colors.PRIMARY1}
                  onClick={(e) => {
                    if (selectedOption != null) return;
                    // if (isInAnalysis) return;
                    e.stopPropagation();
                    showOption(index)
                  }}
                >
                  <span style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ flexGrow: 1, textAlign: 'center', marginLeft: '15px' }}>{warrantyQuote ? <>Resumo da Contratação</> : <>Opção {index + 1}</>}</span>
                    <HasPermission permission={!readOnlyMode}>
                      {(showHistory)
                        ? <Icon name="icon-green_exclamation" className={'icon-green_exclamation'} style={{ textAlign: 'right', marginRight: '15px' }}
                          onClick={(e) => {
                            if (selectedOption != null) return;
                            e.stopPropagation();
                            openHistoryModel && openHistoryModel(index)
                          }} />
                        : <></>}
                      <Icon name="icon-arrow-right-white" className={expanded ? 'icon-arrow-left-white' : 'icon-arrow-right-white'} style={{ textAlign: 'right', marginRight: '15px' }} />
                    </HasPermission>
                  </span>
                </TableHeader>
              )
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow backgroundColor={Colors.GRAY[4]}>
            <TableColumn style={{ borderTopLeftRadius: 12, borderTopRightRadius: 12 }} width={100}>
              <SmallTitle>
                Importância Segurada
                {!showAlterButton && <TitleAlter onClick={() => { history.push(`/edit-enquiry/${idProduct}/${idOperation}`, { isEdit: true }) }}>Alterar</TitleAlter>}
              </SmallTitle>
            </TableColumn>
            {calcList.map((calculations, index) => {
              if (option != null && index != option) return <></>
              const coverageCalc = calculations
              return (
                <>
                  <TableColumn colSpan={6} center >
                    <InlineLabel>
                      Opção {index + 1}
                    </InlineLabel>
                    <Label weight={700}>R$ {maskHelper.formatCurrency(authContext, coverageCalc.coverageLimit)}</Label>
                  </TableColumn>
                </>
              )
            })}
          </TableRow>

          <TableRow>
            <TableColumn width={100}>
              <SmallTitle>
                LMI Acumulado
              </SmallTitle>
            </TableColumn>
            {calcList.map((calculations, index) => {
              if (option != null && index != option) return <></>
              return (
                <TableColumn colSpan={6} center>
                  <InlineLabel>
                    Opção {index + 1}
                  </InlineLabel>
                  <Label>
                    R$ {maskHelper.formatCurrency(authContext, parseNumber(calculations.coverageMaxLimClaimAccumulated))}
                  </Label>
                </TableColumn>
              )
            })}
          </TableRow>

          {(hasCoverageCalc && idProduct == 48) && (
            <TableRow>
              <TableColumn width={100}>
                <SmallTitle>
                  Franquia
                </SmallTitle>
              </TableColumn>
              {calcList.map((calculations, index) => {
                if (option != null && index != option) return <></>
                const coverageCalc = calculations
                return (
                  <TableColumn colSpan={6} center>
                    <InlineLabel>
                      Opção {index + 1}
                    </InlineLabel>
                    <Label>
                      {calculations.deductibleDescription}
                    </Label>
                  </TableColumn>
                )
              })}
            </TableRow>
          )}

          {warrantyQuote && !permissions.NBI_REQUEST_APPROVE_REJECT ? null :
            <>
              <TableRow>
                <TableColumn width={100}>
                  <SmallTitle>
                    Prêmio NET
                  </SmallTitle>
                </TableColumn>
                {calcList.map((calculations, index) => {
                  if (option != null && index != option) return <></>
                  const coverageCalc = calculations
                  return (
                    <TableColumn colSpan={6} center>
                      <InlineLabel>
                        Opção {index + 1}
                      </InlineLabel>
                      <Label>
                        R$ {maskHelper.formatCurrency(authContext, parseNumber(coverageCalc.coverageAmountDiscountLess))}
                      </Label>
                    </TableColumn>
                  )
                })}
              </TableRow>

              <TableRow>
                <TableColumn width={100}>
                  <SmallTitle>
                    Prêmio Líquido
                  </SmallTitle>
                </TableColumn>
                {calcList.map((calculations, index) => {
                  if (option != null && index != option) return <></>
                  const coverageCalc = calculations
                  return (
                    <TableColumn colSpan={6} center>
                      <InlineLabel>
                        Opção {index + 1}
                      </InlineLabel>
                      <Label>
                        R$ {maskHelper.formatCurrency(authContext, parseNumber(coverageCalc.coverageAmountTaxLess))}
                      </Label>
                    </TableColumn>
                  )
                })}
              </TableRow>

            </>
          }

          <TableRow>
            <TableColumn width={100}>
              <SmallTitle>
                Prêmio Total (valor a ser pago)
              </SmallTitle>
            </TableColumn>
            {calcList.map((calculations, index) => {
              if (option != null && index != option) return <></>
              const coverageCalc = calculations
              return (
                <TableColumn colSpan={6} center>
                  <InlineLabel>
                    Opção {index + 1}
                  </InlineLabel>
                  <Label>
                    R$ {
                      maskHelper.formatCurrency(
                        authContext,
                        parseNumber(coverageCalc?.adjustmentCoverageAmount < 0 && coverageCalc?.adjustmentCoverageAmount > coverageCalc.coverageAmount ? 
                          coverageCalc.adjustmentCoverageAmount :
                          coverageCalc.coverageAmount
                        )
                      )
                    }
                  </Label>
                </TableColumn>
              )
            })}
          </TableRow>

          {warrantyQuote && <>
            <TableRow>
              <TableColumn width={100}>
                <SmallTitle>
                  Limite Total do Tomador
                </SmallTitle>
              </TableColumn>
              {calcList.map((calculations, index) => {
                if (option != null && index != option) return <></>
                const coverageCalc = calculations
                return (
                  <TableColumn colSpan={6} center>
                    <InlineLabel>
                      Opção {index + 1}
                    </InlineLabel>
                    <Label>
                      R$ {maskHelper.formatCurrency(authContext, borrowerCreditLimit?.limit || 0)}
                    </Label>
                  </TableColumn>
                )
              })}
            </TableRow>
            <TableRow>
              <TableColumn width={100}>
                <SmallTitle>
                  Limite Minutado do Tomador
                </SmallTitle>
              </TableColumn>
              {calcList.map((calculations, index) => {
                if (option != null && index != option) return <></>
                const coverageCalc = calculations
                return (
                  <TableColumn colSpan={6} center>
                    <InlineLabel>
                      Opção {index + 1}
                    </InlineLabel>
                    <Label>
                      R$ {maskHelper.formatCurrency(authContext, borrowerCreditLimit?.limitDrafted || 0)}
                    </Label>
                  </TableColumn>
                )
              })}
            </TableRow>
            <TableRow>
              <TableColumn width={100}>
                <SmallTitle>
                  Limite Consumido do Tomador
                </SmallTitle>
              </TableColumn>
              {calcList.map((calculations, index) => {
                if (option != null && index != option) return <></>
                const coverageCalc = calculations
                return (
                  <TableColumn colSpan={6} center>
                    <InlineLabel>
                      Opção {index + 1}
                    </InlineLabel>
                    <Label>
                      R$ {maskHelper.formatCurrency(authContext, borrowerCreditLimit?.limitConsumed || 0)}
                    </Label>
                  </TableColumn>
                )
              })}
            </TableRow>
            <TableRow>
              <TableColumn width={100}>
                <SmallTitle>
                  Limite Disponível do Tomador
                </SmallTitle>
              </TableColumn>
              {calcList.map((calculations, index) => {
                if (option != null && index != option) return <></>
                const coverageCalc = calculations
                return (
                  <TableColumn colSpan={6} center>
                    <InlineLabel>
                      Opção {index + 1}
                    </InlineLabel>
                    <Label>
                      R$ {maskHelper.formatCurrency(authContext, borrowerCreditLimit?.availableLimit || 0)}
                    </Label>
                  </TableColumn>
                )
              })}
            </TableRow>

            <TableRow>
              <TableColumn width={100}>
                <SmallTitle>
                  Limite Total da Modalidade
                </SmallTitle>
              </TableColumn>
              {calcList.map((calculations, index) => {
                if (option != null && index != option) return <></>
                const coverageCalc = calculations
                return (
                  <TableColumn colSpan={6} center>
                    <InlineLabel>
                      Opção {index + 1}
                    </InlineLabel>
                    <Label>
                      R$ {maskHelper.formatCurrency(authContext, modalityCreditLimit?.limit || 0)}
                    </Label>
                  </TableColumn>
                )
              })}
            </TableRow>
            <TableRow>
              <TableColumn width={100}>
                <SmallTitle>
                  Limite Minutado da Modalidade
                </SmallTitle>
              </TableColumn>
              {calcList.map((calculations, index) => {
                if (option != null && index != option) return <></>
                const coverageCalc = calculations
                return (
                  <TableColumn colSpan={6} center>
                    <InlineLabel>
                      Opção {index + 1}
                    </InlineLabel>
                    <Label>
                      R$ {maskHelper.formatCurrency(authContext, modalityCreditLimit?.limitDrafted || 0)}
                    </Label>
                  </TableColumn>
                )
              })}
            </TableRow>
            <TableRow>
              <TableColumn width={100}>
                <SmallTitle>
                  Limite Consumido da Modalidade
                </SmallTitle>
              </TableColumn>
              {calcList.map((calculations, index) => {
                if (option != null && index != option) return <></>
                const coverageCalc = calculations
                return (
                  <TableColumn colSpan={6} center>
                    <InlineLabel>
                      Opção {index + 1}
                    </InlineLabel>
                    <Label>
                      R$ {maskHelper.formatCurrency(authContext, modalityCreditLimit?.limitConsumed || 0)}
                    </Label>
                  </TableColumn>
                )
              })}
            </TableRow>
            <TableRow>
              <TableColumn width={100}>
                <SmallTitle>
                  Limite Disponível da Modalidade
                </SmallTitle>
              </TableColumn>
              {calcList.map((calculations, index) => {
                if (option != null && index != option) return <></>
                const coverageCalc = calculations
                return (
                  <TableColumn colSpan={6} center>
                    <InlineLabel>
                      Opção {index + 1}
                    </InlineLabel>
                    <Label>
                      R$ {maskHelper.formatCurrency(authContext, modalityCreditLimit?.availableLimit || 0)}
                    </Label>
                  </TableColumn>
                )
              })}
            </TableRow>
          </>}

          <TableRow>
            <TableColumn width={100}>
              <SmallTitle>
                Comissão
              </SmallTitle>
            </TableColumn>
            {calcList.map((calculations, index) => {
              if (option != null && index != option) return <></>
              const coverageCalc = calculations
              return (
                <TableColumn colSpan={6} center>
                  <InlineLabel>
                    Opção {index + 1}
                  </InlineLabel>

                  <Field style={{ width: '180px', margin: 'auto' }}
                    name={`${formikKey}.${index}.coverageComissionRate`}
                    component={InputField}
                    disabled={(readOnlyMode || disabledCommision) || (!minComission && !maxComission)}
                    type="text"
                    alignCenter
                    mask={{
                      type: "percentage",
                      mask: '% num',
                      blocks: {
                        num: {
                          mask: Number,
                          scale: 5,
                          signed: false,
                          thousandsSeparator: '',
                          padFractionalZeros: true,
                          normalizeZeros: false,
                          radix: ".",
                          max: 100,
                          min: 0
                        }
                      }
                    }}
                    onBlur={(value) => {
                      if (value >= maxComission) {
                        value = maxComission;
                      } else if (value <= minComission) {
                        value = minComission;
                      }
                      onRecalculate && onRecalculate(value / 100, index, 'customComissionRate')
                    }}
                  />
                </TableColumn>
              )
            })}
          </TableRow>

          <TableRow>
            <TableColumn width={100}>
              <SmallTitle>
                Coberturas
              </SmallTitle>
            </TableColumn>
            {calcList.map((calculations, index) => {
              if (option != null && index != option) return <></>
              const coverageCalc = calculations
              return (
                <TableColumn colSpan={6} center>
                  <InlineLabel>
                    Opção {index + 1}
                  </InlineLabel>
                  {!readOnlyMode && <Button
                    disabled={readOnlyMode || disabledConfirm || !permissions.MARKETS_SELECTION}
                    id="btnContinue"
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      onConfirmPlan && onConfirmPlan(index)
                    }}
                    style={{ marginLeft: 'auto', marginRight: 'auto' }}
                    custom={customButton}
                  >
                    {onConfirmPlanText}
                  </Button>}
                </TableColumn>
              )
            })}
          </TableRow>


          <TableRow>
            <TableCollumCoverageItem width={100}>
              <SmallTitle>
                {[34, 48].includes(Number(idProduct)) ? productName : productPlanName}
              </SmallTitle>
            </TableCollumCoverageItem>
            {calcList.map((calculations, index) => {
              if (option != null && index != option) return <></>
              return (
                <>
                  {(!showCoveragesAndExtensions && !expanded) ?
                    <>
                      <TableCollumCoverageItem className={'td-coverage'} colSpan={index === option ? 1 : 6} width={100} noBorder={expanded ? true : false} rightBorder={expanded ? true : false}>
                        <SmallTitle></SmallTitle>
                      </TableCollumCoverageItem>
                    </>
                    :
                    <>
                      <TableCollumCoverageItem className={'td-coverage'} style={{ display: index === option ? 'table-cell' : 'none' }} width={100} noBorder={true} rightBorder={!warrantyQuote ? false : expanded ? true : false}>
                        <SmallTitle>
                          PR. NET
                        </SmallTitle>
                      </TableCollumCoverageItem>
                      <TableCollumCoverageItem className={'td-coverage'} style={{ display: index === option ? 'table-cell' : 'none' }} width={50} noBorder={true}>
                        <SmallTitle>
                          % AJUSTE
                        </SmallTitle>
                      </TableCollumCoverageItem>
                      {warrantyQuote &&
                        <TableCollumCoverageItem
                          className={'td-coverage'}
                          style={{ display: index === option ? 'table-cell' : 'none' }}
                          width={50}
                          noBorder={true}
                        >
                          <SmallTitle>
                            % TAXA
                          </SmallTitle>
                        </TableCollumCoverageItem>}
                      <TableCollumCoverageItem className={'td-coverage'} style={{ display: index === option ? 'table-cell' : 'none' }} width={100} noBorder={true}>
                        <SmallTitle>
                          PR. NET AJUSTADO
                        </SmallTitle>
                      </TableCollumCoverageItem>
                      <TableCollumCoverageItem className={'td-coverage'} colSpan={index === option ? 1 : 6} width={100} noBorder={expanded ? true : false} rightBorder={warrantyQuote ? false : expanded ? true : false}>
                        <SmallTitle>
                          PR. LÍQUIDO
                        </SmallTitle>
                      </TableCollumCoverageItem>
                      {<TableCollumCoverageItem className={'td-coverage'}
                        style={{ display: index === option ? 'table-cell' : 'none' }} width={100}
                        noBorder={true}>
                        <SmallTitle style={{marginLeft: '-10%'}}>
                          LMI
                        </SmallTitle>
                      </TableCollumCoverageItem>}
                    </>
                  }
                </>
              )
            })}
          </TableRow>


          {coverage.map((coverages, covIndex) => {
            const validation = (coverages.coverageAvoidDisable || coverages.coverageDomain === 1 || readOnlyMode || !permissions.NBI_REQUEST_APPROVE_REJECT || newDisabled);
            return (
              <TableRow>
                <TableCollumCoverageItem display={'flex'} style={{ textAlign: "left" }}>
                  {option != null && <Field
                    component={CheckBox}
                    name={`${formikKey}.${option}.coverageItems.${covIndex}.coverageDisabled`}
                    checked={!coverages.coverageDisabled}
                    checkValue
                    disabled={(!permissions.NBI_REQUEST_APPROVE_REJECT && coverages?.coverageMaxLimClaimAdditional) || ((!coverages.coverageAvoidDisable && !isInAnalysis && coverages.coverageDomain !== 1) ? false : validation)}
                    reverseValue
                    onChange={(value) => {
                      handleCheckCoverage && handleCheckCoverage(value, option, coverages.idCoverage)
                    }} />}
                  <Label>{coverages.coverageName}</Label>
                </TableCollumCoverageItem>

                {calcList.map((calculations, index) => {
                  if (option != null && index != option) return <></>
                  return (
                    <>
                      {(!showCoveragesAndExtensions && !expanded) ?
                        <TableCollumCoverageItem colSpan={index === option ? 1 : 6} width={20} noBorder={expanded ? true : false} rightBorder={expanded ? true : false}>
                          {handleIcons(index, covIndex)}
                        </TableCollumCoverageItem>
                        :
                        <>

                          {index === option && (<TableCollumCoverageItem width={20} noBorder={true} rightBorder={!warrantyQuote ? false : expanded ? true : false}>
                            <InlineLabel>
                              PR. NET
                            </InlineLabel>
                            {formikValues?.calculationList[index].coverageItems[covIndex]?.coverageDisabled ?
                              <Field
                                style={{ width: '80%', marginBottom: '0px', margin: "auto" }}
                                name={'defaultValueCoverageDisabled'}
                                component={InputField}
                                type="text"
                                validation={false}
                                disabled={true}
                                readOnly={true}
                              /> :
                              <Field
                                style={{ width: '80%', marginBottom: '0px', margin: "auto" }}
                                mask={currencyMask()}
                                name={`${formikKey}.${index}.coverageItems.${covIndex}.coveragePremium`}
                                component={InputField}
                                type="text"
                                validation={false}
                                disabled={readOnlyMode || !permissions.NBI_REQUEST_APPROVE_REJECT || disabled || formikValues?.calculationList[index].coverageItems[covIndex]?.coverageDisabled || formikValues?.calculationList[index].coverageItems[covIndex]?.coverageMaxLimClaimAdditional}
                                readOnly={true}
                              />
                            }
                          </TableCollumCoverageItem>)}

                          {index === option && (<TableCollumCoverageItem width={20} noBorder={true}>
                            <InlineLabel>
                              AJUSTE %
                            </InlineLabel>
                            {formikValues?.calculationList[index].coverageItems[covIndex]?.coverageDisabled ?
                              <Field
                                style={{ width: '100%', marginBottom: '0px', margin: "auto" }}
                                name={'defaultValueCoverageDisabled'}
                                component={InputField}
                                type="text"
                                validation={false}
                                disabled={true}
                                readOnly={true}
                              /> :
                              <Field
                                style={{ width: '100%', marginBottom: '0px', margin: "auto" }}
                                name={`${formikKey}.${index}.coverageItems.${covIndex}.coveragePremiumDiscountRate`}
                                component={InputField}
                                type="text"
                                validation={false}
                                mask={maskHelper.getPercentage(authContext.region, 6, "5000.000000", "-5000.000000")}
                                disabled={readOnlyMode || !permissions.NBI_REQUEST_APPROVE_REJECT || disabled || formikValues?.calculationList[index].coverageItems[covIndex]?.coverageDisabled || formikValues?.calculationList[index].coverageItems[covIndex]?.coverageMaxLimClaimAdditional}
                                onBlur={(value) => onRecalculate && onRecalculate(value / 100, index, 'customCoveragePremiumDiscountRate')}
                              />
                            }
                          </TableCollumCoverageItem>)}

                          {warrantyQuote && index === option && <TableCollumCoverageItem width={20} noBorder={true}>
                            <InlineLabel>
                              TAXA %
                            </InlineLabel>
                            {formikValues?.calculationList[index].coverageItems[covIndex]?.coverageDisabled ?
                              <Field
                                style={{ width: '80%', marginBottom: '0px', margin: "auto" }}
                                name={'defaultValueCoverageDisabled'}
                                component={InputField}
                                type="text"
                                validation={false}
                                disabled={true}
                                readOnly={true}
                              /> :
                              <Field
                                style={{ width: '80%', marginBottom: '0px', margin: "auto" }}
                                name={`${formikKey}.${index}.coverageItems.${covIndex}.coverageRate`}
                                component={InputField}
                                type="text"
                                validation={false}
                                mask={idProduct == 34 ? maskHelper.getPercentage(authContext.region, 6, "5000.000000", "-5000.000000") : maskHelper.getPercentage(authContext.region, 4, "100", "-100")}
                                disabled={readOnlyMode || !permissions.NBI_REQUEST_APPROVE_REJECT || disabled || formikValues?.calculationList[index].coverageItems[covIndex]?.coverageDisabled || formikValues?.calculationList[index].coverageItems[covIndex]?.coverageMaxLimClaimAdditional}
                                onBlur={(value) => onRecalculateItem && onRecalculateItem(value / 100, index, coverages.idCoverage, 'customCoverageRate')}
                              />
                            }
                          </TableCollumCoverageItem>}


                          {index === option && (<TableCollumCoverageItem width={20} noBorder={true}>
                            <InlineLabel>
                              PR. NET AJUSTADO
                            </InlineLabel>
                            {formikValues?.calculationList[index].coverageItems[covIndex]?.coverageDisabled ?
                              <Field
                                style={{ width: '80%', marginBottom: '0px', margin: "auto" }}
                                name={'defaultValueCoverageDisabled'}
                                component={InputField}
                                type="text"
                                validation={false}
                                disabled={true}
                                readOnly={true}
                              /> :
                              <Field
                                style={{ width: '80%', marginBottom: '0px', margin: "auto" }}
                                mask={currencyMask()}
                                name={`${formikKey}.${index}.coverageItems.${covIndex}.coveragePremiumDiscountLess`}
                                component={InputField}
                                type="text"
                                validation={false}
                                disabled={readOnlyMode || !permissions.NBI_REQUEST_APPROVE_REJECT || disabled || formikValues?.calculationList[index].coverageItems[covIndex]?.coverageDisabled || formikValues?.calculationList[index].coverageItems[covIndex]?.coverageMaxLimClaimAdditional}
                                readOnly={true}
                              />
                            }
                          </TableCollumCoverageItem>)}

                          <TableCollumCoverageItem colSpan={index === option ? 1 : 6} width={20} noBorder={expanded ? true : false} rightBorder={warrantyQuote ? false : expanded ? true : false}>
                            {/* {(!showCoveragesAndExtensions) && handleIcons(index, covIndex)} */}
                            <>
                              <InlineLabel>
                                PR. LÍQUIDO {index + 1}
                              </InlineLabel>
                              {formikValues?.calculationList[index].coverageItems[covIndex]?.coverageDisabled ?
                                <Field
                                  style={{ width: option != null ? '80%' : '180px', marginBottom: '0px', margin: "auto" }}
                                  name={'defaultValueCoverageDisabled'}
                                  component={InputField}
                                  type="text"
                                  validation={false}
                                  disabled={true}
                                  readOnly={true}
                                /> :
                                <Field
                                  style={{ width: option != null ? '80%' : '180px', marginBottom: '0px', margin: "auto" }}
                                  mask={currencyMask()}
                                  name={`${formikKey}.${index}.coverageItems.${covIndex}.coveragePremiumTaxLess`}
                                  component={InputField}
                                  type="text"
                                  validation={false}
                                  disabled={readOnlyMode || !permissions.NBI_REQUEST_APPROVE_REJECT || disabled || formikValues?.calculationList[index].coverageItems[covIndex]?.coverageDisabled || formikValues?.calculationList[index].coverageItems[covIndex]?.coverageMaxLimClaimAdditional}
                                  readOnly={true}
                                />
                              }
                            </>
                          </TableCollumCoverageItem>


                          {index === option && (<TableCollumCoverageItem width={20} noBorder={true}>
                            <InlineLabel>
                              LMI
                            </InlineLabel>
                            <RowValue>
                              { !formikValues?.calculationList[index].coverageItems[covIndex]?.coverageDisabled ? 
                                <Field
                                  style={{ width: '80%', margin: '0' }}
                                  mask={currencyMask(formikValues?.calculationList[index].coverageItems[covIndex].coverageLimit)}
                                  name={`${formikKey}.${index}.coverageItems.${covIndex}.coverageMaxLimClaim`}
                                  component={InputField}
                                  type="text"
                                  validation={false}
                                  disabled={true}
                                  onBlur={(value) => onRecalculateItem && onRecalculateItem(value, index, coverages.idCoverage, 'coverageMaxLimClaim', 'coverageMaxLimClaimRate')}
                                /> :
                                <Field
                                  style={{ width: '80%', margin: '0' }}
                                  mask={currencyMask(formikValues?.calculationList[index].coverageItems[covIndex].coverageLimit)}
                                  component={InputField}
                                  type="text"
                                  validation={false}
                                  disabled={true}
                                />
                              }
                            </RowValue>
                          </TableCollumCoverageItem>)}
                        </>
                      }
                    </>
                  )
                })}
              </TableRow>
            )
          })}


          <TableRow>
            <TableColumn>

            </TableColumn>
            {calcList.map((calculations, index) => {
              if (option != null && index != option) return <></>
              return (
                <TableColumn colSpan={6} center>
                </TableColumn>
              )
            })}
          </TableRow>

        </TableBody>
      </TableComponent>
      {warrantyQuote ? <ExtraText>* Poderá sofrer alteração durante a análise de risco</ExtraText> : null}
    </>
  )
}

export default Table;
